import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';

export interface Props {
    onReady: (canvas: HTMLCanvasElement) => void;
}

export const Component = (props: Props) => {
    const canvasRef = Hooks.useRef<HTMLCanvasElement>();

    return (
        <canvas
            style={{ width: '100%', height: '100%', outline: 'none' }}
            ref={canvas => {
                if (
                    canvas !== null &&
                    (canvasRef.current === undefined || !canvasRef.current.isSameNode(canvas))
                ) {
                    canvasRef.current = canvas;
                    props.onReady(canvasRef.current);
                }
            }}
        ></canvas>
    );
};

Component.displayName = 'Canvas';
